import * as React from 'react';
import { useSelector } from 'react-redux';

import Space from 'antd/lib/space';
import Text from 'antd/lib/typography/Text';
import { antGrey, releaseStepDetailsContainerModuleStyle, runwayColors } from '../styles/globalStyles';
import { TestRun } from '../../types';
import RegressionTestingCharts from './regressionTestingCharts';
import { iconAndAltForIntegrationType } from '../../helpers/integrationHelpers';
import Collapse from 'antd/lib/collapse';
import Progress from 'antd/lib/progress/progress';
import RegressionTestingRunHeader from './RegressionTestingRunHeader';
import { RootState } from '../../reducers/reducers';
import { selectAppTimeFormatSetting, selectEffectiveTimezone } from '../../selectors/selectors';

interface RegressionTestingActiveTestRunsProps {
    testRuns: TestRun[];
    currentTestRunsPercentComplete?: number;
    appId: string;
}

const RegressionTestingActiveTestRuns: React.FC<RegressionTestingActiveTestRunsProps> = (
    props: RegressionTestingActiveTestRunsProps,
) => {
    const use24HourTimeFormat = useSelector((state: RootState) => selectAppTimeFormatSetting(state, props.appId));
    const effectiveTimezone = useSelector((state: RootState) => selectEffectiveTimezone(state, props.appId));

    return (
        <div
            style={{
                marginBottom: 24,
                display: 'flex',
                flexDirection: 'column',
                flexGrow: 1,
                minWidth: 0,
            }}
        >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                <Text style={{ fontSize: 20, color: antGrey.grey7, marginBottom: 16 }}>Current test runs</Text>
                {props.currentTestRunsPercentComplete && (
                    <Space>
                        <Progress
                            percent={props.currentTestRunsPercentComplete}
                            strokeColor={runwayColors.statusGreen}
                            showInfo={false}
                            type="line"
                            style={{ width: 200 }}
                        />
                        <Text type="secondary">{props.currentTestRunsPercentComplete}% complete</Text>
                    </Space>
                )}
            </div>
            <div
                style={{
                    ...releaseStepDetailsContainerModuleStyle,
                    marginBottom: 25,
                }}
            >
                <Collapse className="adjust-collapse-icon" ghost>
                    {props.testRuns.map((testRun: TestRun, index: number) => {
                        const { name, integrationId, url, createdAt, completedAt, completionFraction } = testRun;

                        const [icon, alt] = iconAndAltForIntegrationType(integrationId);
                        const percentComplete = parseFloat((completionFraction * 100).toFixed(0));

                        return (
                            <Collapse.Panel
                                className="collapse-test-runs"
                                key={index}
                                header={
                                    <RegressionTestingRunHeader
                                        name={name}
                                        integrationIcon={icon}
                                        integrationIconAlt={alt}
                                        percentComplete={percentComplete}
                                        completedAt={completedAt}
                                        url={url}
                                        createdAt={createdAt}
                                        use24HourTimeFormat={use24HourTimeFormat}
                                        effectiveTimezone={effectiveTimezone}
                                    />
                                }
                            >
                                <RegressionTestingCharts {...testRun} />
                            </Collapse.Panel>
                        );
                    })}
                </Collapse>
            </div>
        </div>
    );
};

export default RegressionTestingActiveTestRuns;
